// extracted by mini-css-extract-plugin
export default {"container":"IsNewTemplate_container__VF+IZ","button":"IsNewTemplate_button__11eMR","new":"IsNewTemplate_new__kFqU+","old":"IsNewTemplate_old__R-Fic"};